export default "__VITE_ASSET__d0fb8980__"